export default __webpack_public_path__ + "static/media/navbar-subscribers-dark.f6c68b2c.svg";